import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { loadAllCartItems} from '@app/actions/shoppingmall/cart.action';
import { setWAlert } from '@app/actions/w-alert.action';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { AuthUtil } from '@app/common/util/auth.util';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { WAlertStatus } from '@app/models/components/w-alert-stauts.model';
import { OrderMstModel } from '@app/models/myoffice/order/order-mst.model';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { CartState, getAllCartItems, getCartInfo } from '@app/selectors/shoppingmall/cart.selector';
import { WAlertState, getWAlertStatus } from '@app/selectors/w-alert.selector';
import { CartService } from '@app/services/shoppingmall/cart.service';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'list-cart',
  templateUrl: './list-cart.component.html',
  styleUrls: ['./list-cart.component.css']
})
export class ListCartComponent implements OnInit, OnDestroy {
  @Input() 
  urlWownet : String = "";

  @Input()
  show: boolean = false;

  @Output()
  clickClosePopup = new EventEmitter<boolean>();

  mapCart: Map<OrderMstModel, OrdPdtModel[]> = new Map();

  cartAllItems$ = new Observable<OrdPdtModel[]>();
  cartAllItems: OrdPdtModel[] = [];
  listOrd: OrdPdtModel[] = [];
  cartInfo$ = new Observable<OrderMstModel[]>();
  cartInfo: OrderMstModel[] = [];
  allCartItemSub$: Subscription = {} as Subscription;
  allCartInfoSub$: Subscription = {} as Subscription;

  wAlertStatus$ = new Observable<WAlertStatus>();
  
  pdtCd: string = '';
  quantity: number = 1;
  cateNameOrg: string = '';

  constructor(
    private _cartStore: Store<CartState>,
    private _wAlertStore: Store<WAlertState>,
    private _cartSerivce: CartService
  ) { 
    this.cartAllItems$ = this._cartStore.select(getAllCartItems);
    this.cartInfo$ = this._cartStore.select(getCartInfo);
    this.wAlertStatus$ = this._wAlertStore.select(getWAlertStatus);
  }

  ngOnDestroy(): void {
    let hasValue = this.allCartItemSub$.closed != undefined
    if(this.allCartItemSub$ && hasValue) {
      this.allCartItemSub$.unsubscribe();
    }
    let hasValue1 = this.allCartInfoSub$.closed != undefined
    if(this.allCartInfoSub$ && hasValue1) {
      this.allCartInfoSub$.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.allCartInfoSub$ = this.cartInfo$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.cartInfo = res;  
        this.loadAllCartItem();
      }
    });

    this.allCartItemSub$ = this.cartAllItems$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.mapCart = new Map();
        this.cartAllItems = res;       
        
        for(let i=0; i<this.cartInfo.length; i++) {
          let tmp = []
          for(let j=0; j<this.cartAllItems.length; j++) {
            if(this.cartInfo[i].ordNoTmp == this.cartAllItems[j].ordNoTmp) {
              // console.log(this.cartAllItems[j])
              tmp.push(this.cartAllItems[j])
              this.mapCart.set(this.cartInfo[i], tmp);
            }
          }
        }     
      }
    });

    this.wAlertStatus$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) { 
        this.pdtCd = res.pdtCd;
        this.quantity = res.quantity;
        this.cateNameOrg = res.cateNameOrg;
      }
    });
  }

  handleClickChooseCart(item : OrderMstModel) {
    let listCurrent : any = this.mapCart.get(item);
    if(Number(item.countPoint) > 0) {
      if(this.cateNameOrg == 'O06') {
        if((this.quantity + listCurrent[0].qty) <= listCurrent[0].saleMaxQty) {
          this._cartSerivce.handleAddCartItemLogin(this.pdtCd, this.quantity, ConvertUtil.convertToSring(item.ordNoTmp));
        } else {
          this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.warning, message: listCurrent[0].pdtName + ' 최대 ' + listCurrent[0].saleMaxQty + ' 개만 주문할 수 있습니다.' } }));
        }
                
      } else {
        this._cartSerivce.showAlertNotOtherProduct();
      }
    } else {
      if(this.cateNameOrg == 'O06') {
        this._cartSerivce.showAlertNotPointProduct();
      } else {
        if((this.quantity + listCurrent[0].qty) <= listCurrent[0].saleMaxQty){
          this._cartSerivce.handleAddCartItemLogin(this.pdtCd, this.quantity, ConvertUtil.convertToSring(item.ordNoTmp));
        } else {
          this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.warning, message: listCurrent[0].pdtName + ' 최대 ' + listCurrent[0].saleMaxQty + ' 개만 주문할 수 있습니다.' } }));
        }
      }
    }
    this.handleOnClickClosePopup();
  }

  handleOnClickClosePopup(): void {
    this.clickClosePopup.emit(false);
  }

  loadAllCartItem() {
    if (AuthUtil.isLogined()) {
      let member = AuthUtil.getLoginedInfo();
      if(member) {
        this._cartStore.dispatch(loadAllCartItems({ userid: ConvertUtil.convertToSring(member.userid)}))
      } 
    }
  }
}
